import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { init, pageView } from '../../../utils/analytics';

/**
 * Sends page_view to Google Analytics on every route change.
 * Must be mounted inside a Router (HistoryRouter/BrowserRouter).
 * No-op if REACT_APP_GA_MEASUREMENT_ID is not set.
 */
function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    pageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
}

export default GoogleAnalytics;
